import SeaFooter from "./footer-sea";
import HmtFooter from "./footer-hmt";

const Footer = ({ env }: { env: string }) => {
  if (env == "hmt") {
    return <HmtFooter />;
  }

  return <SeaFooter />;
};

export default Footer;
